import { BodyText, Flex, IconV2, Link } from '@bamboohr/fabric';

export const PasskeyFacts: React.FC<{
	hasMaxWidth?: boolean;
	showLearnMore?: boolean;
}> = ({ hasMaxWidth = false, showLearnMore = false }) => {
	return (
		<Flex
			flexDirection="column"
			gap={2}
			maxWidth={hasMaxWidth ? 436 : undefined}
		>
			<BodyText>
				{$.__('Passkeys let you log in without a password.')}{' '}
				{$.__(
					'They use your device’s built-in security to log in with your fingerprint, face, or PIN.',
				)}{' '}
				{showLearnMore && (
					<Link href="https://fidoalliance.org/passkeys/" target="_blank">
						{$.__('Learn more')}
					</Link>
				)}
			</BodyText>
			<Flex component="ul" flexDirection="column" gap={1.5}>
				<Flex alignItems="center" component="li" gap={1}>
					<IconV2 color="primary-strong" name="fingerprint-solid" size={16} />
					<BodyText weight="medium">
						{$.__('More secure than passwords')}
					</BodyText>
				</Flex>
				<Flex alignItems="center" component="li" gap={1}>
					<IconV2 color="primary-strong" name="check-solid" size={16} />
					<BodyText weight="medium">{$.__('Easy setup')}</BodyText>
				</Flex>
				<Flex alignItems="center" component="li" gap={1}>
					<IconV2
						color="primary-strong"
						name="rabbit-running-solid"
						size={16}
					/>
					<BodyText weight="medium">{$.__('Faster sign-in')}</BodyText>
				</Flex>
			</Flex>
		</Flex>
	);
};
